export default {
  type: 'provided_service',
  config: {
    relationships: {
      "case": {
        type: 'case'
      },
      program: {
        type: 'program'
      },
      plan: {
        type: 'plan'
      },
      zcodes: {
        type: 'zcode'
      },
      place_of_service: {
        type: 'place_of_service'
      },
      procedure_codes: {
        type: 'procedure_code'
      },
      procedure_code_modifiers: {
        type: 'procedure_code_modifier'
      }
    }
  }
};
//# sourceMappingURL=provided_service.js.map